import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, isStaff } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;

  // Show access denied page instead of redirecting — prevents staff from being
  // wrongly sent to student login due to race conditions
  if (!isStaff) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background px-4">
        <div className="text-center space-y-3">
          <h1 className="text-xl font-bold text-foreground">Acesso Restrito</h1>
          <p className="text-sm text-muted-foreground">
            Esta área é exclusiva para professores e administradores.
          </p>
          <p className="text-sm text-muted-foreground">
            Se você é aluno, acesse{" "}
            <a href="/aluno/login" className="text-primary underline">a área do aluno</a>.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
